import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectImage24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconMediaObjectImage24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.5 4.5H5A1.5 1.5 0 0 0 3.5 6v8.44l1.97-1.97.434-.435.512.341L13 16.766V6a1.5 1.5 0 0 0-1.5-1.5M3.5 18v-1.5l.03.03 2.566-2.565 6.815 4.544a1.5 1.5 0 0 1-1.411.991H5A1.5 1.5 0 0 1 3.5 18M5 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h6.5a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm11.25 4.25A.75.75 0 0 1 17 6.5h4.227a.75.75 0 0 1 0 1.5H17a.75.75 0 0 1-.75-.75M17 10a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5zM9.5 9a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M11 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectImage24);
